import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconCaretUpDown from './assets/caretUpDown.svg?react';

export const Label = styled.label`
    display: inline-flex;
    position: relative;
    cursor: pointer;
    user-select: none;
    height: 36px;

    & input:disabled ~ div {
        cursor: initial;
        border: 2px solid ${(props) => props.theme.colors['surface-grey-200']};
        background-color: ${(props) => props.theme.colors['surface-white']};
        color: ${(props) => props.theme.colors['text-grey-700']};
        fill: ${(props) => props.theme.colors['text-grey-700']};
    }

    /* On mouse-over when NOT checked */
    &:hover input:not(:checked):not(:disabled) ~ div {
        color: ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        fill: ${(props) => props.theme.colors['myzanichelli-blue-dark']};
    }

    /* On mouse-over when NOT checked */
    &:hover input:checked:not(:disabled) ~ div {
        color: ${(props) => props.theme.colors['text-white']};
        background-color: ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        fill: ${(props) => props.theme.colors['text-white']};
    }

    /* When the checkbox is checked, add a blue background */
    & input:checked ~ div {
        background-color: ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-dark']};
        color: ${(props) => props.theme.colors['text-white']};
        fill: ${(props) => props.theme.colors['text-white']};
    }

    /** Input active NOT checked */
    & input:active:not(:checked):not(:disabled) ~ div {
        border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-light']};
        color: ${(props) => props.theme.colors['text-myzanichelli-blue-light']};
        box-shadow: ${(props) => props.theme.shadows['shadow-02dp']};
        fill: ${(props) => props.theme.colors['text-myzanichelli-blue-light']};
    }

    /** Input active checked */
    & input:active:checked:not(:disabled) ~ div {
        background-color: ${(props) => props.theme.colors['myzanichelli-blue-light']};
        border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-light']};
        box-shadow: ${(props) => props.theme.shadows['shadow-02dp']};
    }

    /** Fallback for browser without focus-visible */
    & input:focus:not(:active) ~ div {
        box-shadow: var(--outline);
    }

    /** Remove mouse-focus for browser that support functionality */
    & input:focus:not(:focus-visible):not(:active) ~ div {
        box-shadow: none;
    }

    & input:focus-visible:not(:active) ~ div {
        box-shadow: var(--outline);
    }
`;

export const Checkbox = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`;

export const FakeButton = styled.div`
    min-width: 64px;
    user-select: none;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 36px;
    border-radius: 4px;
    padding: 0 8px;

    outline: none;
    box-sizing: border-box;
    border: none;

    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.16px;
    line-height: 20px;
    white-space: nowrap;

    cursor: pointer;

    transition-duration: 0.25s;

    background-color: ${(props) => props.theme.colors['surface-white']};
    color: ${(props) => props.theme.colors['myzanichelli-blue-main']};
    border: 2px solid ${(props) => props.theme.colors['myzanichelli-blue-main']};
    fill: ${(props) => props.theme.colors['text-myzanichelli-blue-main']};
`;

export const IndicatorContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-weight: 400;

    & > *:not(:last-child) {
        margin-right: 4px;
    }

    & > svg {
        width: 16px;
        height: 16px;
    }
`;

const SortButton = ({
    children,
    disabled = false,
    checked = false,
    onChange = () => {},
    inputType = 'checkbox',
    inputName, // Required for inputType radio
    stringIndicator = '',
    withIndicator = false,
}) => {
    const [state, setState] = useState(checked);

    useEffect(() => {
        setState(checked);
    }, [checked]);

    const handleChange = (e) => {
        setState(e.target.checked);
        onChange(e.target.checked);
    };

    return (
        <Label>
            <Checkbox disabled={disabled} type={inputType} name={inputName} checked={state} onChange={handleChange} />
            <FakeButton>
                <span>{children}</span>
                {withIndicator && (
                    <IndicatorContainer>
                        <span>{stringIndicator}</span>
                        <IconCaretUpDown />
                    </IndicatorContainer>
                )}
            </FakeButton>
        </Label>
    );
};

SortButton.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    inputType: PropTypes.oneOf(['checkbox', 'radio']),
    inputName: PropTypes.string,
    stringIndicator: PropTypes.string,
    withIndicator: PropTypes.bool,
};

export default SortButton;
